<template>
  <div id="app">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {
    this.onInit();
  },
  mounted() {

  },
  methods: {
    async onInit() {

    },
  },
};
</script>
<style lang="scss">
#app {
  font-size: 14px;
  width: 100vw;
  height: 100vh;
  background: #f9f9f9;
}
</style>
